import React, { ReactElement, useContext } from 'react'
// Commons imports.
import TextInput from '../../Common/Components/TextInput'
import FormRow from '../../Common/Components/FormRow'
import P from '../../Common/Components/P'
import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { DisplayOptions } from '../../../../i18n'
// CSS imports. Commented out because of current build process.
// import './callStateThresholds.scss'

/**
 * Component properties type.
 */
type Props = {
    externalURL: string
    setExternalURL: (value: string) => void
}

/**
 * Call state thresholds section in Alarms tab of report configuration modal window.
 *
 * @param externalURL External URL string.
 * @param setExternalURL Sets the external URL string.
 */
const ExternalDisplayOptions: React.FC<Props> = ({ externalURL, setExternalURL }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('DisplayOptions')

    return (
        <React.Fragment>
            <P>{language?.get(DisplayOptions.ExternalURL1)}</P>
            <P>
                <span className='warningText'>{language?.get(DisplayOptions.ExternalURL2)}</span>
            </P>
            <FormRow className={'url'}>
                <TextInput
                    value={externalURL}
                    labelLeft={language?.get(DisplayOptions.LabelURL)}
                    onChange={(value): void => {
                        setExternalURL(value)
                    }}
                />
            </FormRow>
        </React.Fragment>
    )
}

export default ExternalDisplayOptions
